import React, { useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getAuthorization, getHeaders } from '../../request';
import { SttTranslateHook } from '@stt-componentes/core';
import ListaAnexos from './anexos';
import { useSignal, useSignals } from '@preact/signals-react/runtime';
import SttGaleriaImagens from '@stt-componentes/galeria-telediagnostico';
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
	divListaImagens: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2)
	}
}));

const Imagens = ({ idExame }) => {
	const { strings } = useContext(SttTranslateHook.I18nContext);
	const classes = useStyles();
	useSignals();

	const outrosAnexos = useSignal([]);

	useEffect(() => {
		axios
			.get(`${global.gConfig.url_base_exames}/exame/${idExame}/anexo`, { headers: getHeaders() })
			.then((response) => {
				outrosAnexos.value = response.data;
			})
			.catch((err) => {
				console.log('err', err);
			});
	}, []);

	return (
		<>
			<SttGaleriaImagens
				idExame={idExame}
				strings={strings}
				config={global.gConfig}
				tokenTelessaude={getAuthorization()}
			/>
			{outrosAnexos.value.length > 0 && (
				<div className={classes.divListaImagens}>
					<ListaAnexos anexos={outrosAnexos} />
				</div>
			)}
		</>
	);
};
export default Imagens;
